export const LOCAL_STORAGE_KEY = 'influencer-monitor';

const LocalStorageService = {
  setItem<T>(key: string, data: T) {
    if (data === undefined || data === null) {
      this.removeItem(key);
      return;
    }
    localStorage.setItem(`${LOCAL_STORAGE_KEY}-${key}`, JSON.stringify(data));
  },
  getItem(key: string) {
    const item = localStorage.getItem(`${LOCAL_STORAGE_KEY}-${key}`);
    if (item === 'undefined' || item === 'null') {
      this.removeItem(key);
      return null;
    }
    return item ? JSON.parse(item) : null;
  },
  removeItem(key: string) {
    localStorage.removeItem(`${LOCAL_STORAGE_KEY}-${key}`);
  }
};

export default LocalStorageService;
